// Lo que TODA tabla que se ordena tocando su cabecera hace igual.
//
// Salio de `taskSort.js`, que lo resolvio primero para la tabla de Tareas
// (Lissette 2026-08-21). Al pedir lo mismo para Pagos del Mes (2026-09-01:
// "en modulo de pago tambien podria colocar para ordenarlo ascendente o
// descendente, menor a mayor?") habia dos caminos: copiar esas dos funciones o
// sacarlas a un sitio comun. Copiadas, el dia que una de las dos tablas
// cambiara de criterio la otra se quedaria atras sin que nadie lo notara
// (E-138). Aqui viven una sola vez; cada tabla pone lo suyo, que es de donde
// sale el valor de cada columna.

// Compara dos valores ya extraidos de sus filas.
//
// Lo VACIO se va siempre al final, suba o baje el orden: una lista que empieza
// con doce guiones no sirve para nada. Un 0 no es vacio — es un dato, y ordena.
export function compararValores(va, vb, dir, es) {
  const aVacio = va === '';
  const bVacio = vb === '';
  if (aVacio !== bVacio) return aVacio ? 1 : -1;
  if (aVacio && bVacio) return 0;
  const r = (typeof va === 'number' && typeof vb === 'number')
    ? va - vb
    : String(va).localeCompare(String(vb), es ? 'es' : 'en');
  return dir === 'desc' ? -r : r;
}

// Tocar el encabezado: sube, baja, y la tercera devuelve el orden por defecto.
// Nunca se queda uno atrapado en un orden que no sabe deshacer.
export function siguienteOrden(sortBy, sortDir, key) {
  if (sortBy !== key) return { sortBy: key, sortDir: 'asc' };
  if (sortDir === 'asc') return { sortBy: key, sortDir: 'desc' };
  return { sortBy: '', sortDir: 'asc' };
}

// La flechita del encabezado. Sin orden puesto no se pinta nada: una flecha
// gris en todas las columnas es ruido, y no dice cual manda.
export function flechaDeOrden(sortBy, sortDir, key) {
  if (sortBy !== key) return '';
  return sortDir === 'desc' ? ' ↓' : ' ↑';
}
